import { render } from "./GeneralAffairsVendorCancelModal.vue?vue&type=template&id=fb3d3146&scoped=true"
import script from "./GeneralAffairsVendorCancelModal.vue?vue&type=script&lang=js"
export * from "./GeneralAffairsVendorCancelModal.vue?vue&type=script&lang=js"

import "./GeneralAffairsVendorCancelModal.vue?vue&type=style&index=0&id=fb3d3146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3d3146"]])

export default __exports__